import {FC} from 'react'
import {cn} from 'src/app/utils/cn-utils'
import {chipTheme} from './Chip.theme'
import {GChipProps} from './Chip.types'

export const GChip: FC<GChipProps> = ({children, variant, uppercase, className}) => {
  return <span className={cn(chipTheme({variant, className}), {uppercase})}>{children}</span>
}
